module.exports = __webpack_public_path__ + "img/instagram.63e47346.svg";